import DatabaseModel from './DatabaseModel.js';
import FileUtils from '../FileUtils.js';
import Utils from '../Utils.js';

var Documento = Object.create(DatabaseModel);

Documento.model = 'core/documento';

Documento.download = function(documento) {
    var self = this;
    self.getDocumento(documento).then(function(data) {
        var blob = new Blob([data]);
        if (typeof cordova != 'undefined') {
            FileUtils.openFile(data, documento.nombre + '.' + documento.extension, () => _ ,() => _);
        } else if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, documento.nombre + '.' + documento.extension);
        } else {
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = documento.nombre + '.' + documento.extension;
            link.target = '_blank';
            link.click();
            URL.revokeObjectURL(link.href);
        }
    });
}

Documento.getBase64 = function(documento, callbackOk, callbackError) {
    var self = this;
    self.getDocumento(documento).then(function(arrayBuffer) {
        console.log("OBTENIDO DOCUMENTO", documento);
        let base64 = window.btoa(
            new Uint8Array(arrayBuffer)
              .reduce((data, byte) => data + String.fromCharCode(byte), '')
          );
        console.log("TRANFORMADO A BASE64 DOCUMENTO", documento);
        // let b642 = arrayBuffer.toString('base64');
        callbackOk(base64);
    
    }).catch(e => callbackError(e));
}

/**
 * Copia del documento con solo lo que el servidor necesita para localizarlo: fuera los campos de
 * trabajo del front (los que empiezan por `_`: `_base64`, `_scaledBase64`, `_previewBase64_…`,
 * `_localURL`...). Importa especialmente en las URLs públicas, que llevan el documento serializado en
 * la query: al previsualizar, rFiles guarda la foto entera en `_previewBase64_…` dentro del propio
 * item y la URL de la miniatura pasaba a medir megabytes y fallaba (en la APK, que no convierte la
 * miniatura a base64, se quedaba la imagen rota hasta recargar).
 *
 * Si no es un objeto se devuelve tal cual: las plantillas de email piden la descarga pasando solo el
 * path como texto, y `Object.keys` de un string lo trocea en letras y el servidor recibía path null.
 */
Documento.paraServidor = function (documento, paraUrl) {
    if (documento === null || typeof documento !== 'object') {
        return documento;
    }
    const copia = {};
    Object.keys(documento || {}).forEach(function (clave) {
        if (!clave.startsWith('_')) {
            copia[clave] = documento[clave];
        }
    });
    if (paraUrl) {
        delete copia.camposPersonalizados;
        delete copia.camposPDF;
    }
    return copia;
};

Documento.getDocumento = function(documento, responseType = 'arraybuffer') {
    var self = this;
    return new Promise(function(resolve, reject) {
        self.request.promise({
            url: self.server_movilidad + self.prefix + self.model + '/download',
            method: 'POST',
            contentType: 'application/json',
            crossDomain: true,
            xhrFields: { 'responseType': responseType },
            data: self.paraServidor(documento)
        }).then(function({ data, xhr, status }) {
            if (data.error) {
                reject(data);
            } else {
                resolve(data);
            }
        }).catch(function({ xhr, status, message }) {
            try {
                reject(JSON.parse(xhr.response).error);
            } catch (e) {
                reject(xhr.response);
            }
        });
    });
}

Documento.downloadZip = function(documentos, responseType = 'arraybuffer') {
    var self = this;
    return new Promise(function(resolve, reject) {
        self.request.promise({
            url: self.server_movilidad + self.prefix + self.model + '/downloadZip',
            method: 'POST',
            contentType: 'application/json',
            crossDomain: true,
            xhrFields: { 'responseType': responseType },
            data: documentos
        }).then(function({ data, xhr, status }) {
            if (data.error) {
                reject(data);
            } else {
                try {
                    var blob = new Blob([data], { type: 'application/octet-stream' });
                    // vamos a crear un string con la fecha actual en formato yyyyMMddHHmmssSSS
                    var t = new Date();
                    var timestampStr = t.getTime().toString();
                    var filename = 'documentos-'+timestampStr+'.zip';
                    if (xhr && typeof xhr.getResponseHeader === 'function') {
                        var disposition = xhr.getResponseHeader('content-disposition') || xhr.getResponseHeader('Content-Disposition');
                        if (disposition && disposition.indexOf('filename=') !== -1) {
                            filename = disposition.split('filename=')[1].replace(/"/g, '').trim();
                        }
                    }

                    if (typeof cordova != 'undefined') {
                        FileUtils.openFile(data, filename, () => _ ,() => _);
                    } else if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(blob, filename);
                    } else {
                        var link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = filename;
                        link.target = '_blank';
                        link.click();
                        URL.revokeObjectURL(link.href);
                    }
                    resolve(data);
                } catch (e) {
                    reject(e);
                }
            }
        }).catch(function({ xhr, status, message }) {
            try {
                reject(JSON.parse(xhr.response).error);
            } catch (e) {
                reject(xhr.response);
            }
        });
    });
}

Documento.getDocumentoScaled = function(documento, responseType = 'arraybuffer') {
    var self = this;
    return new Promise(function(resolve, reject) {
        self.request.promise({
            url: self.server_movilidad + self.prefix + self.model + '/downloadScaled',
            method: 'POST',
            contentType: 'application/json',
            crossDomain: true,
            xhrFields: { 'responseType': responseType },
            data: documento
        }).then(function({ data, xhr, status }) {
            if (data.error) {
                reject(data);
            } else {
                resolve(data);
            }
        }).catch(function({ xhr, status, message }) {
            try {
                reject(JSON.parse(xhr.response).error);
            } catch (e) {
                reject(xhr.response);
            }
        });
    });
}

Documento.getDocumentoByPath = function (path) {
    var self = this;
    if (!path) return;
    var params = {
        url: self.server_movilidad + self.prefix + self.model + '/' ,
        method: 'POST',
        contentType: 'application/json',
        dataType: 'json',
        crossDomain: true,
        data: { path: path }
    };
    return self.sendRequest(params, true);

}

Documento.ls = function (path) {
    var self = this;
    if (!path) return;
    var params = {
        url: self.server_movilidad + self.prefix + self.model + '/ls',
        method: 'POST',
        contentType: 'application/json',
        dataType: 'json',
        crossDomain: true,
        data: { path: path }
    };
    return self.sendRequest(params, true);

}

Documento.upload = function(files, fileData) {
    var self = this;
    var data = new FormData();
    data.append("files", files[0]);
    if(fileData){
        if(fileData.tipo){ data.append("tipo", fileData.tipo); }
        if(fileData.path){ data.append("path", fileData.path); }
        if(fileData.conservarNombre){ data.append("conservarNombre", fileData.conservarNombre); }
        if(fileData.sobrescribir){ data.append("sobrescribir", fileData.sobrescribir); }
        if(fileData.comentario){ data.append("comentario", fileData.comentario); }
        // si el campo selected no es undefined, lo actualizamos
        if(typeof fileData.selected != 'undefined'){ data.append("selected", fileData.selected); }
    }
    return new Promise(function(resolve, reject) {
        self.request.promise({
            url: self.server_movilidad + self.prefix + self.model + '/upload',
            method: 'POST',
            crossDomain: true,
            dataType: 'json',
            data: data
        }).then(function({ data, xhr, status }) {
            if (data.error) {
                reject(data);
            } else {
                resolve(data);
            }
        }).catch(function({ xhr, status, message }) {
            try {
                reject(JSON.parse(xhr.response).error);
            } catch (e) {
                reject(xhr.response);
            }
        });
    });
}

Documento.dataToFiles = function(fileData, fileName) {
    const b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
        const byteCharacters = window.atob(b64Data);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);

            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }

        const blob = new Blob(byteArrays, { type: contentType });
        return blob;
    }

    if(!fileData.base64 && fileData._base64) {
        fileData.base64 = fileData._base64;
    }
    var file = null;
    if (fileData.base64){
        let base64 = fileData.base64;
        if (fileData.base64.indexOf(",") > -1) {
            base64 = fileData.base64.split(",")[1];
        }
        file = b64toBlob([base64]);
    } else {
        file = fileData;
    }
    var formData = new FormData();
    formData.append("file", file, fileName);
    return [formData.get("file")];
}

Documento.uploadData = function(fileData) {
    const self = this;
    var fileName = fileData.extension ? `${fileData.nombre}.${fileData.extension}` : fileData.nombre;
    var files = Documento.dataToFiles(fileData, fileName);
    return self.upload(files, fileData);
}

Documento.getDocumentoData = function(fileData) {
    const self = this;
    return window.atob(fileData.split(',')[1]);
}

Documento.uploadTo = function(fileData, path, forcedName, tipo, forzar) {
    var fileName = ((forcedName) ? forcedName : fileData.nombre) + `.${fileData.extension}`;
    var files = Documento.dataToFiles(fileData, fileName);
    if(tipo) { fileData.tipo = tipo; }
    if(path) {
        fileData.path = path;
        fileData.conservarNombre = true;
        if(forzar) { fileData.sobrescribir = true; }
    }
    return Documento.upload(files, fileData);
}

Documento.moveTo = function(documento, path, name, forzar){
    const self = this;
    var data = {
        documento: documento,
        pathDestino: path,
        newName: name,
        conservarNombre: true
    };
    if(forzar){ data.sobrescribir = true; }

    return new Promise(function(resolve, reject) {
        self.request.promise({
            url: self.server_movilidad + self.prefix + self.model + '/move',
            method: 'POST',
            crossDomain: true,
            contentType: 'application/json',
            dataType: 'json',
            data: data
        }).then(function({ data, xhr, status }) {
            if (data.error) {
                reject(data);
            } else {
                self.resetCache();
                resolve(data);
            }
        }).catch(function({ xhr, status, message }) {
            try {
                reject(JSON.parse(xhr.response).error);
            } catch (e) {
                reject(xhr.response);
            }
        });
    });
}

Documento.delete = function(documento) {
    var self = this;
    var params = {
        url: self.server_movilidad + self.prefix + self.model + '/delete',
        method: 'POST',
        crossDomain: true,
        contentType: 'application/json',
        dataType: 'json',
        data: documento
    };
    return self.sendRequest(params, false).then(res => {
        self.resetCache();
        return res;
    });
}

Documento.updatePDF = function (documentoPDF, documentoInicial) {
    var self = this;
    var params = {
        url: self.server_movilidad + self.prefix + self.model + '/updatePDF' ,
        method: 'POST',
        contentType: 'application/json',
        dataType: 'json',
        crossDomain: true,
        data: {
            nuevoDocumento: documentoPDF.archivo[0],
            documentoInicial: documentoInicial.archivo[0]
        }
    };
    return self.sendRequest(params, false);
}

Documento.guardarCamposPDF = function(documentoPDF, updateCamposPDF) {
    var self = this;
    var params = {
        url: self.server_movilidad + self.prefix + self.model + '/updateCamposPDF' ,
        method: 'POST',
        contentType: 'application/json',
        dataType: 'json',
        crossDomain: true,
        data: {
            documento: documentoPDF,
            campos: updateCamposPDF
        }
    };
    return self.sendRequest(params, false);
}

Documento.getPDFByPath = function (path) {
    var self = this;
    if (!path) return;
    var documento = {path: path};
    return new Promise(function(resolve, reject) {
        self.request.promise({
            url: self.server_movilidad + self.prefix + self.model + '/pdf',
            method: 'POST',
            contentType: 'application/json',
            crossDomain: true,
            xhrFields: { 'responseType': 'arraybuffer' },
            data: documento
        }).then(function({ data, xhr, status }) {
            if (data.error) {
                reject(data);
            } else {
                resolve(data);
            }
        }).catch(function({ xhr, status, message }) {
            try {
                reject(JSON.parse(xhr.response).error);
            } catch (e) {
                reject(xhr.response);
            }
        });
    });

}

Documento.downloadPDFReferenciasByPath = function(documento) {
    var self = this;
    self.getPDFByPath(documento.path).then(function(data) {
        var blob = new Blob([data]);
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, documento.nombre + '.' + documento.extension);
        } else {
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = documento.nombre + '.' + documento.extension;
            link.target = '_blank';
            link.click();
            URL.revokeObjectURL(link.href);
        }
    });
}

Documento.getDocumentoPublicUrl = function (documento) {
    var self = this;
    let url = self.server_movilidad + self.prefix + 'core/public' + '/download';
    url = url + '?token=' + Utils.getToken();
    const documentoForUrl = self.paraServidor(documento, true);
    url = url + '&documento=' + Buffer.from(JSON.stringify(documentoForUrl)).toString("base64");
    return url;
}

Documento.getDocumentoScaledUrl = function (documento) {
    var self = this;
    let url = self.server_movilidad + self.prefix + 'core/public' + '/download';
    url = url + '?token=' + Utils.getToken();
    // Agregar parametro para indicar que queremos la version escalada
    const documentoForUrl = Object.assign(self.paraServidor(documento, true), { scaled: true });
    url = url + '&documento=' + Buffer.from(JSON.stringify(documentoForUrl)).toString("base64");
    return url;
}

export default Documento;
